import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { NotFoundState } from "./notFound.state";
import { NotFoundData } from "./notFound.types";
import { getNotFoundData } from "./notFound.thunk";

const initialState: NotFoundState = {
  data: null,
  status: "idle",
  error: null,
  currentSlug: null,
};

export const notFoundSlice = createSlice({
  name: "notFound",
  initialState,
  reducers: {
    resetNotFound: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotFoundData.pending, (state, action) => {
        state.status = "loading";
        state.error = null;
        state.currentSlug = action.meta.arg;
      })
      .addCase(
        getNotFoundData.fulfilled,
        (state, action: PayloadAction<NotFoundData>) => {
          state.status = "success";
          state.data = action.payload;
        }
      )
      .addCase(
        getNotFoundData.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Sayfa bulunamadı.";
        }
      );
  },
});

export const { resetNotFound } = notFoundSlice.actions;
export default notFoundSlice.reducer;
